import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { PageSection, PageHeaderBar } from "components/page";
import { RestrictedToAdmin } from "components/auth";
import FormTextField from "components/form/form-textfield";
import { EventStatusSelect } from "components/select";

const RestrictedData = ({ intl, values, handleChange }) => {
  return (
    <RestrictedToAdmin>
      <PageHeaderBar subtitle title="app.page.event.form.restrictedData" />
      <PageSection spaced>
        <DataGrid>
          <DataGridItem>
            <FormTextField
              type="text"
              id="urlMixerBert"
              name="urlMixerBert"
              value={values.urlMixerBert || ""}
              onChange={handleChange}
              label={intl.formatMessage({ id: "event.urlMixerBert" })}
            />
          </DataGridItem>
          <DataGridItem>
            <FormTextField
              marginDense
              type="text"
              id="urlRemoteProduction"
              name="urlRemoteProduction"
              value={values.urlRemoteProduction || ""}
              onChange={handleChange}
              label={intl.formatMessage({ id: "event.remoteProduction.url" })}
            />
          </DataGridItem>
          <DataGridItem>
            <FormTextField
              marginDense
              type="text"
              id="elasticIp"
              name="elasticIp"
              value={values.elasticIp || ""}
              onChange={handleChange}
              label={intl.formatMessage({ id: "event.elasticIp" })}
            />
          </DataGridItem>
          <DataGridItem>
            <EventStatusSelect
              isInsideForm
              label={intl.formatMessage({ id: "event.eventStatus" })}
              onChange={handleChange}
              value={values.eventStatus}
            />
          </DataGridItem>
        </DataGrid>
      </PageSection>
    </RestrictedToAdmin>
  );
};

RestrictedData.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(RestrictedData);
